import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router'
import { LightchartComponent } from './lightchart/lightchart.component';
import { BadlamarketComponent } from './badlamarket/badlamarket.component';
import { BadlaorderComponent } from './badlaorder/badlaorder.component';
import { EndbadlaorderComponent } from './endbadlaorder/endbadlaorder.component';
import { UnauthpageComponent } from './unauthpage/unauthpage.component';
import {AuthGuard} from "./auth-gaurd/auth-guard.service";
import { LivebadlaComponent } from './livebadla/livebadla.component';
import { LoginComponent } from './login/login.component';
import { BadlaorderdetailComponent } from './badlaorderdetail/badlaorderdetail.component';
import { SettlementoldComponent } from './settlementold/settlementold.component';
import { HistoryComponent } from './history/history.component';
import { OldbadlaComponent } from './oldbadla/oldbadla.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'chart/:instId', component: LightchartComponent },
  { path: 'badla/:type/:authToken', component: BadlamarketComponent },  
  { path: 'livebadla/:authToken', component: LivebadlaComponent },
  { path: 'badlaorder',canActivate: [AuthGuard], component: BadlaorderComponent },
  { path: 'endbadlaorder', component: EndbadlaorderComponent },
  { path: 'summery', component: SettlementoldComponent },
  { path: 'history', component: HistoryComponent },  
  { path: 'order-detail/:detailId', component: BadlaorderdetailComponent },
  {path: 'unauth', component: UnauthpageComponent},
  { path: 'oldbadla/:authToken', component:  OldbadlaComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
